import type { AuthSource } from '@/shared/lib/auth';

/** Sessão autenticada na api-v2 (plataforma NPS). */
export function isNpsSession(authSource: AuthSource | null | undefined): boolean {
  return authSource === 'v2';
}
